import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { ApiUrl } from '../constants/apiUrl';
import { Contract } from '../models/entities/contract';
import { VContract } from '../models/entities/v-contract';
import { ListResponseModel } from '../models/responseModels/list-response-model';
import { ObjectResponseModel } from '../models/responseModels/object-response-model';
import { ResponseModel } from '../models/responseModels/response-model';

@Injectable({
  providedIn: 'root'
})
export class ContractService {

  constructor(private httpClient: HttpClient, private router: Router, private toastrService: ToastrService) { }

  getList(): Observable<ListResponseModel<VContract>> {
    return this.httpClient.get<ListResponseModel<VContract>>(ApiUrl.url + "Contract/getList");
  }

  getById(id: number): Observable<ObjectResponseModel<Contract>> {
    return this.httpClient.get<ObjectResponseModel<Contract>>(ApiUrl.url + "Contract/getById?Id=" + id);
  }

  getListByPortalId(portalId: number): Observable<ListResponseModel<VContract>> {
    return this.httpClient.get<ListResponseModel<VContract>>(ApiUrl.url + "Contract/getListByPortalId?portalId=" + portalId);
  }

  getListByCustomerId(customerId: number): Observable<ListResponseModel<VContract>> {
    return this.httpClient.get<ListResponseModel<VContract>>(ApiUrl.url + "Contract/getListByCustomerId?customerId=" + customerId);
  }

  getListByIds(customerId: number, portalId: number) {
    return this.httpClient.get<ListResponseModel<VContract>>(ApiUrl.url + "Contract/getListByIds?customerId=" + customerId + "&portalId=" + portalId);
  }

  getListByContractTypeId(contractTypeId: number): Observable<ListResponseModel<VContract>> {
    return this.httpClient.get<ListResponseModel<VContract>>(ApiUrl.url + "Contract/getListByContractTypeId?contractTypeId=" + contractTypeId);
  }

  getLastRecordId(): Observable<ObjectResponseModel<number>> {
    return this.httpClient.get<ObjectResponseModel<number>>(ApiUrl.url + "Contract/getLastRecordId");
  }

  add(contract: Contract) {
    return this.httpClient.post<ObjectResponseModel<Contract>>(ApiUrl.url + "Contract/add", contract);
  }

  update(contract: Contract) {
    return this.httpClient.post<ResponseModel>(ApiUrl.url + "Contract/update", contract);
  }

  delete(id: number) {
    return this.httpClient.post<ResponseModel>(ApiUrl.url + "Contract/delete?Id=" + id, "");
  }

}
